import { ServiceProxyMap, createAxiosClient } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '' }, ServiceProxyMap.PAPI);

export enum ExportJSONTypes {
  QUOTE = 'quote',
  INVOICE = 'invoice',
}

export enum ExportJSONStatus {
  SUCCESS = 'SUCCESS',
  ACCEPTED = 'ACCEPTED',
  INELIGIBLE = 'INELIGIBLE',
  FAILED = 'FAILED',
}

export type RequestJSON = {
  type: ExportJSONTypes;
  id: string;
  transactionAccountId: string;
};

export type ExportJSONResponse = {
  data?: string;
  messsage?: string;
  status?: ExportJSONStatus;
};

export type VerifyJSONResponse = {
  isJSONAvailable: boolean;
};

export const downloadJsonById = async (request: RequestJSON): Promise<ExportJSONResponse> => {
  const response = await client.get(`/api/v1/${request.type}/${request.id}/download`, {
    headers: {
      'X-transaction-account': request.transactionAccountId,
    },
  });
  const data = response?.data?.contents?.[0]?.body; // base-64 encoded string
  return {
    data,
    status: response?.data?.status,
    messsage: response?.data?.messsage,
  };
};

export const verifyJsonById = async (request: RequestJSON): Promise<VerifyJSONResponse> => {
  const response = await client.get(`/api/v1/${request.type}/${request.id}/verify`, {
    headers: {
      'X-transaction-account': request.transactionAccountId,
    },
  });

  return {
    isJSONAvailable: response?.data?.isExists,
  };
};
